import React from 'react';
import {
  Form,
  Grid,
} from '@mairistem/composants';
import { Date, Panel } from '@mairistem/finances-utils';
import { MULTI, Sens } from '@mairistem/comptabilite';
import dayjs, { type Dayjs } from 'dayjs';
import { isNil } from 'lodash';
import type PanelComponentProps from '../../../interfaces/pieces/mouvements/panelComponentProps';

const PeriodeCouverteComponent = ({
  data,
  handlePin,
  onChange,
  panel,
  sens,
}: PanelComponentProps) => {
  const anneeExerciceSup = !isNil(data?.exercice?.anneeExercice) ? data.exercice.anneeExercice + 1 : 0;

  const detailCalculJours = React.useCallback(() => {
    const dateFin = dayjs(data?.dateFinCharge);
    const dateDebut = dayjs(data?.dateDebutCharge);

    const dateFinAnnee = dateFin?.isAfter(`${anneeExerciceSup}-01-01`)
      ? dayjs(`${data?.exercice?.anneeExercice}-12-31`)
      : dateFin;

    let dayX = dateFinAnnee.diff(dateDebut, 'day') + 1;

    if (dayX < 0) {
      dayX = 0;
    }
    if (dayX >= 365) {
      if (dateFinAnnee?.isBefore(`${data?.exercice?.anneeExercice}-01-01`)) {
        dayX = 0;
      }
      dayX = 365;
    }

    const dateDebutAnneeSup = dateDebut?.isAfter(`${anneeExerciceSup}-01-01`)
      ? dateDebut
      : dayjs(`${anneeExerciceSup}-01-01`);

    const dateFinAnneeSup = dateFin?.isAfter(`${anneeExerciceSup}-12-31`)
      ? dayjs(`${anneeExerciceSup}-12-31`)
      : dateFin;

    let dayY = dateFinAnneeSup.diff(dateDebutAnneeSup, 'day') + 1;

    if (dayY < 0) {
      dayY = 0;
    } else if (dayY > 365) {
      dayY = 365;
    }

    return (
      <Grid>
        <Grid.Column width={2}>
          Soit:
        </Grid.Column>
        <Grid.Column width={14}>
          <Grid.Row>
            {`${dayX} jour${(dayX > 1) ? 's' : ''} sur l'exercice ${data?.exercice?.anneeExercice}`}
          </Grid.Row>
          <Grid.Row>
            {`${dayY} jour${((dayY) > 1) ? 's' : ''} sur l'exercice ${anneeExerciceSup} 
              (constaté${(data?.sens === Sens.DEPENSE) ? 'e' : ''} d'avance)`}
          </Grid.Row>
        </Grid.Column>
      </Grid>
    );
  }, [
    anneeExerciceSup,
    data?.dateDebutCharge,
    data?.dateFinCharge,
    data?.exercice?.anneeExercice,
    data?.sens,
  ]);

  const handleChangeDate = (value: string, name: string) => onChange({ [name]: value }, panel);

  return (
    <Panel panel={panel} onPin={handlePin} sens={sens}>
      <Form>
        <Form.Group>
          <Form.Field
            control={Date}
            data-testid="periodeCouvertePeriodeDebutInput"
            disabled={data?.dateDebutCharge === MULTI}
            // @ts-expect-error disabledDate
            disabledDate={(date: Dayjs) => date.isBefore(dayjs(`${data?.exercice?.anneeExercice}-01-01`))
              || date.isAfter(dayjs(data?.dateFinCharge === MULTI ? `${anneeExerciceSup}-12-31` : data?.dateFinCharge))}
            fluid
            label="Date de début"
            name="dateDebutCharge"
            onChange={handleChangeDate}
            value={data?.dateDebutCharge}
            width={8}
          />
          <Form.Field
            control={Date}
            data-testid="periodeCouvertePeriodeFinInput"
            disabled={data?.dateFinCharge === MULTI}
            // @ts-expect-error disabledDate
            disabledDate={(date: Dayjs) => date.isBefore(dayjs(data?.dateDebutCharge === MULTI
              ? `${data?.exercice?.anneeExercice}-01-01` : data?.dateDebutCharge))
              || date.isAfter(dayjs(`${anneeExerciceSup}-12-31`))}
            fluid
            label="Date de fin"
            name="dateFinCharge"
            onChange={handleChangeDate}
            value={data?.dateFinCharge}
            width={8}
          />
        </Form.Group>
        {(data?.dateDebutCharge === MULTI || data?.dateFinCharge === MULTI) ? (
          MULTI
        ) : detailCalculJours()}
      </Form>
    </Panel>
  );
};

export default PeriodeCouverteComponent;
